import { useNode } from "@craftjs/core";
import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import SettingsTitleWrapper from "@/components/editor/shared/settings-title-wrapper";
import { Input } from "@/components/shared/forms";
import ImageUpload from "@/content-hub/editor/components/image-upload";
import type { MediaItem } from "@/content-hub/page/domain";

export default function ImageSettings() {
  const { altText, actions, defaultSrc, nodeId, imageMetadata } = useNode(
    (node) => ({
      blockType: node.data.props?.blockType,
      altText: node.data.props?.alt ?? "",
      defaultSrc: node.data.props?.defaultSrc ?? "",
      imageMetadata: node.data.props?.imageMetadata ?? null,
      nodeId: node.id,
    })
  );
  const { t } = useTranslation();

  const onUpload = useCallback(
    (imageMetadata: MediaItem) => {
      actions.setProp((props) => {
        props.imageMetadata = imageMetadata;
      });
    },
    [actions]
  );

  return (
    <ImageSettingsWrapper>
      <SettingsTitleWrapper title="Image">
        <div className="grid gap-2">
          <ImageUpload
            uploadTransactionId={nodeId}
            imageMetadata={imageMetadata}
            onUpload={onUpload}
            defaultImage={defaultSrc}
          />
          <p className="text-sm leading-6 text-gray-600">
            {t("preference-panel.please-use-formats")}
          </p>
          <Input
            className="mt-4"
            name="a"
            value={altText}
            onChange={(e) => {
              actions.setProp((props) => {
                props.alt = e.currentTarget.value;
              });
            }}
            label={t("preference-panel.image-alt-text")}
          />
        </div>
      </SettingsTitleWrapper>
    </ImageSettingsWrapper>
  );
}

const ImageSettingsWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex flex-col p-4">{children}</div>;
};
